<template>
  <div>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
    >
      <path
        d="M5.11508 13.9131C4.41134 14.307 3.7568 14.799 3.16797 15.3826C4.34105 16.5446 5.83101 17.3871 7.49519 17.7672C6.33727 16.8585 5.56672 15.3138 5.11508 13.9131Z"
        fill="#9B237B"
      />
      <path
        d="M9.75781 17.9777C10.8565 17.8549 11.8923 16.9576 12.6984 15.4188C12.9773 14.8863 13.2172 14.2986 13.4155 13.6686C12.2873 13.1224 11.0479 12.8183 9.75781 12.7822V17.9777Z"
        fill="#9B237B"
      />
      <path
        d="M0.5 9.24927C0.563054 11.4581 1.42555 13.4701 2.80763 15.0059C3.4566 14.3639 4.18086 13.8271 4.96067 13.403C4.60662 12.1327 4.40959 10.7188 4.38877 9.24932L0.5 9.24927Z"
        fill="#9B237B"
      />
      <path
        d="M9.24025 5.7163C7.90008 5.68084 6.61162 5.37156 5.43494 4.81543C5.11093 6.01366 4.93031 7.34404 4.91016 8.72851H9.24025V5.7163Z"
        fill="#9B237B"
      />
      <path
        d="M9.23962 12.7825C7.95011 12.8186 6.71054 13.1228 5.58203 13.6691C5.7803 14.2991 6.02018 14.8866 6.29905 15.419C7.10506 16.9578 8.14094 17.855 9.23962 17.9779V12.7825Z"
        fill="#9B237B"
      />
      <path
        d="M9.24025 9.24902H4.91016C4.93031 10.6336 5.11098 11.9641 5.435 13.1624C6.61198 12.606 7.90065 12.2966 9.24025 12.2611V9.24902Z"
        fill="#9B237B"
      />
      <path
        d="M9.75781 8.72846H14.0879C14.0678 7.34404 13.8871 6.01361 13.5632 4.81543C12.3865 5.37156 11.098 5.68079 9.75781 5.71625V8.72846Z"
        fill="#9B237B"
      />
      <path
        d="M18.4996 9.24902H14.6109C14.59 10.7185 14.393 12.1322 14.0391 13.4023C14.8189 13.8265 15.5429 14.3635 16.192 15.0057C17.5741 13.4699 18.4366 11.4579 18.4996 9.24902Z"
        fill="#9B237B"
      />
      <path
        d="M11.5039 17.7673C13.1682 17.3872 14.6582 16.5447 15.8312 15.3826C15.2423 14.7988 14.588 14.3066 13.8842 13.9126C13.4338 15.3096 12.664 16.857 11.5039 17.7673Z"
        fill="#9B237B"
      />
      <path
        d="M16.1918 2.97168C15.5429 3.61378 14.8189 4.1508 14.0391 4.57499C14.3931 5.84518 14.5901 7.25897 14.6109 8.72847H18.4997C18.4367 6.51946 17.5741 4.50741 16.1918 2.97168Z"
        fill="#9B237B"
      />
      <path
        d="M9.75781 5.1953C11.0479 5.15921 12.2873 4.85509 13.4154 4.30895C13.2171 3.67888 12.9773 3.0913 12.6984 2.55886C11.8924 1.02011 10.8565 0.122879 9.75781 0V5.1953Z"
        fill="#9B237B"
      />
      <path
        d="M9.75781 12.2611C11.098 12.2965 12.3865 12.6057 13.5632 13.1618C13.8871 11.9637 14.0678 10.6334 14.0879 9.24902H9.75781V12.2611Z"
        fill="#9B237B"
      />
      <path
        d="M9.23967 0C8.14099 0.122827 7.10516 1.02011 6.29911 2.55886C6.02023 3.09135 5.7803 3.67893 5.58203 4.3089C6.71023 4.85509 7.94959 5.15921 9.23967 5.1953V0Z"
        fill="#9B237B"
      />
      <path
        d="M13.8842 4.06495C14.5879 3.67101 15.2422 3.17877 15.8311 2.59499C14.658 1.43299 13.1681 0.59049 11.5039 0.210449C12.6615 1.11861 13.4322 2.66319 13.8842 4.06495Z"
        fill="#9B237B"
      />
      <path
        d="M7.49514 0.210449C5.83096 0.59049 4.34105 1.43294 3.16797 2.59493C3.7568 3.17871 4.41118 3.67091 5.11493 4.06495C5.56672 2.66366 6.33732 1.11882 7.49514 0.210449Z"
        fill="#9B237B"
      />
      <path
        d="M4.38882 8.72858C4.40965 7.25902 4.60667 5.84529 4.96067 4.57499C4.18091 4.15085 3.45691 3.61383 2.80789 2.97168C1.42566 4.50746 0.563054 6.51956 0.5 8.72852L4.38882 8.72858Z"
        fill="#9B237B"
      />
    </svg>
  </div>
</template>
<script>
export default {};
</script>
